<template>
  <el-card class="h-full absolute inset-0 z-10">
    <div class="h-full flex flex-col">
      <div class="mb-10px">
        <span
          class="border-l-3 border-color-primary pl-10px text-18px"
          v-if="operateType !== 'read'"
          >{{ pageTitle }}</span
        >
        <el-page-header v-else @back="dialogVisible = false" :content="pageTitle"></el-page-header>
      </div>
      <div class="flex-1 overflow-y-auto pr-100px">
        <el-form
          :model="formData"
          ref="formRef"
          label-width="150px"
          :rules="formRules"
          :disabled="operateType === 'read'"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item :label="`${$t('培训名称')}`" prop="name">
                <el-input
                  v-model="formData.name"
                  :placeholder="`${$t('请输入')}`"
                  :maxlength="30"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('培训类型')}`" prop="trainingType">
                <el-select
                  v-model="formData.trainingType"
                  size="small"
                  :placeholder="`${$t('培训类型')}`"
                  clearable
                  class="w-full"
                  filterable
                >
                  <el-option
                    v-for="(item, index) in trainingType"
                    :key="index"
                    :label="item.displayName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('培训课件')}`" prop="coursewares">
                <el-select
                  v-model="formData.coursewares"
                  size="small"
                  class="w-full"
                  :placeholder="`${$t('培训课件')}`"
                  clearable
                  multiple
                  filterable
                  @change="courseHandle"
                >
                  <el-option
                    v-for="(item, index) in courseList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="`${$t('合格学分')}`" prop="qualifiedCredits">
                <el-input
                  v-model="formData.qualifiedCredits"
                  :placeholder="`${$t('请输入')}`"
                  oninput="value=value.replace(/[^0-9]/g,'')"
                  @blur="formData.qualifiedCredits = $event.target.value"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('考试计划关联')}`" prop="violationTime">
                <el-input />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('发起人')}`" prop="publisherId">
                <person-singer-select
                  v-model="formData.publisherId"
                  @sentData="changePersonSelect"
                  :disabled="operateType === 'read'"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="`${$t('培训期限')}`" prop="trainingDate">
                <el-date-picker
                  type="daterange"
                  range-separator="至"
                  v-model="formData.trainingDate"
                  clearable
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width:100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('提醒时间')}`" prop="reminderTime">
                <el-date-picker
                  v-model="formData.reminderTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width:100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('合格学时')}`" prop="qualifiedCreditHours">
                <div class="flex">
                  <!-- <el-input
                  v-model="formData.qualifiedCreditHours"
                  :placeholder="`${$t('请输入')}`"
                /> -->
                  <el-input
                    v-model="timer[0]"
                    oninput="value=value.replace(/[^0-9]/g,'')"
                    @blur="timer[0] = $event.target.value"
                    @change="numLimit(0, false)"
                  />
                  <span class="mr-5px ml-5px">:</span>
                  <el-input
                    v-model="timer[1]"
                    oninput="value=value.replace(/[^0-9]/g,'')"
                    @blur="timer[1] = $event.target.value"
                    @change="numLimit(1, true)"
                  />
                  <span class="mr-5px ml-5px">:</span>
                  <el-input
                    v-model="timer[2]"
                    oninput="value=value.replace(/[^0-9]/g,'')"
                    @blur="timer[2] = $event.target.value"
                    @change="numLimit(2, false)"
                  />
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="`${$t('培训人员')}`" prop="persons">
                <el-input
                  size="small"
                  v-model="formData.persons"
                  readonly
                  placeholder="请选择"
                  style="flex:1"
                >
                  <template slot="append">
                    <el-button
                      @click="showSelectDialog = true"
                      :disabled="operateType === 'read'"
                      type="primary"
                      >选择</el-button
                    >
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="`${$t('培训公告')}`" prop="notice">
                <el-input
                  type="textarea"
                  v-model="formData.notice"
                  :placeholder="`${$t('请输入')}`"
                  show-word-limit
                  :maxlength="500"
                  :autosize="{ minRows: 2 }"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="pl-40px mt-20px">
          <el-table
            :data="tableList"
            border
            class="w-full"
            stripe
            show-summary
            :summary-method="getSummary"
          >
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column label="课件名称" prop="name" show-overflow-tooltip></el-table-column>
            <el-table-column label="时长" prop="times" show-overflow-tooltip
              ><template slot-scope="scope">
                <span>{{ scope.row.times | showText('second') }}</span>
              </template></el-table-column
            >
            <el-table-column label="节点数量" prop="nodes" show-overflow-tooltip></el-table-column>
            <el-table-column
              label="试题数量"
              prop="questions"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="是否必修" prop="isCompulsory">
              <template slot-scope="scope">
                <span v-if="operateType === 'read'">{{
                  scope.row.isCompulsory ? '必修' : '选修'
                }}</span>
                <el-select v-model="scope.row.isCompulsory" v-else @change="compulsoryChange">
                  <el-option label="必修" :value="true"></el-option>
                  <el-option label="选修" :value="false"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="学分" prop="credit">
              <template slot-scope="scope">
                <span v-if="operateType === 'read'">{{ scope.row.credit }}</span>
                <el-input-number
                  v-else
                  v-model="scope.row.credit"
                  :min="0"
                  size="small"
                  :precision="0"
                /> </template
            ></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="flex justify-center mt-20px" v-if="this.operateType !== 'read'">
        <el-button type="primary" size="small" @click="submitForm" :loading="loading"
          >保存</el-button
        >
        <el-button size="small" @click="dialogVisible = false" :loading="loading">取消</el-button>
      </div>
    </div>
    <PersonManySelect
      :visible.sync="showSelectDialog"
      :selectedPersonList="personList"
      v-if="showSelectDialog"
      @getSelectedList="getPersonList"
    />
  </el-card>
</template>

<script>
import { TrainingPlanApi } from '@wiz-api/training-management'
import dayjs from 'dayjs'
import { formatSeconds } from '../EnumField'

const PersonManySelect = () => {
  return import('@/modules/safety-factor-sm/components/SelectPeople')
}
const PersonSingerSelect = () => {
  return import('@/components/safety/FormSelect/PersonSelect')
}

const trainingPlanApi = new TrainingPlanApi()
export default {
  name: 'train-relTrain',
  components: { PersonManySelect, PersonSingerSelect },
  filters: {
    showText: (val, type) => {
      let result = ''
      if (type === 'time') {
        result = val.lastModificationTime || val.creationTime
      }
      if (type === 'second') {
        result = formatSeconds(val)
      }
      return result
    },
  },
  props: {
    operateType: {
      default: '',
      type: String,
    },
    operateData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    visible: {
      type: Boolean,
      default: false,
    },
    trainingType: {
      type: Array,
      default: () => {
        return []
      },
    },
    courseList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  data() {
    return {
      formRules: {
        name: [{ required: true, message: this.$t('请输入'), trigger: ['blur', 'change'] }],
        trainingType: [{ required: true, message: this.$t('请输入'), trigger: ['blur', 'change'] }],
        coursewares: [{ required: true, message: this.$t('请输入'), trigger: ['blur', 'change'] }],
        qualifiedCreditHours: [
          { required: true, message: this.$t('请输入'), trigger: ['blur', 'change'] },
        ],
        qualifiedCredits: [
          { required: true, message: this.$t('请输入'), trigger: ['blur', 'change'] },
        ],
        trainingDate: [{ required: true, message: this.$t('请输入'), trigger: ['blur', 'change'] }],
        persons: [{ required: true, message: this.$t('请输入'), trigger: ['blur', 'change'] }],
      },
      formData: {
        name: '',
        trainingType: '',
        qualifiedCredits: undefined,
        examId: null,
        examName: null,
        publisherId: '',
        publisherName: '',
        trainingDate: '',
        reminderTime: '',
        qualifiedCreditHours: undefined,
        notice: '',
        coursewares: [],
        persons: '',
      },
      tableList: [],
      loading: false,
      showSelectDialog: false,
      personList: [],
      pageTitle: '',
      timer: ['00', '00', '00'],
    }
  },
  mounted() {
    const title = {
      create: '新增',
      update: '编辑',
      read: '详情',
    }
    this.pageTitle = this.$t(title[this.operateType])
    if (this.operateType === 'create') {
      const userInfo = Wiz.AuthHooks.GetUserInfo()
      const data = userInfo?.profile
      this.formData.publisherName = data.given_name
      this.formData.publisherId = data.sub
    } else if (this.operateType === 'update' || this.operateType === 'read') {
      this.initInfoData()
    }
  },

  methods: {
    numLimit(val) {
      if (Number(this.timer[val]) < 0) {
        this.timer.splice(val, 1, '')
        this.formData.qualifiedCreditHours = ''
        return
      }
      if (val > 0 && Number(this.timer[val]) > 60) {
        this.timer.splice(val, 1, '')
        this.formData.qualifiedCreditHours = ''
        return
      }
      if (this.timer[0] && this.timer[1] && this.timer[2]) {
        this.formData.qualifiedCreditHours =
          this.timer[0] * 3600 + this.timer[1] * 60 + Number(this.timer[2])
      }
    },
    // 合计
    getSummary(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[0] = '合计'
        }
        if ([2, 3, 4, 6].includes(index)) {
          sums[index] = data.reduce((pre, cur) => {
            pre += cur[column.property] || 0
            return pre
          }, 0)
          if (index === 2) {
            sums[index] = formatSeconds(sums[index])
          }
        }
      })
      return sums
    },
    // 详情
    async initInfoData() {
      const [err, res] = await trainingPlanApi.getPlan({ id: this.operateData.id })
      if (err) return
      Object.keys(this.formData).forEach((key) => {
        this.formData[key] = res[key]
      })
      this.formData.trainingDate = [res.trainingDateStart, res.trainingDateEnd]
      this.timer = formatSeconds(res.qualifiedCreditHours).split(':')

      // 课件处理
      const coursewaresId = res.coursewares.map((item) => {
        return item.coursewareId
      })
      this.formData.coursewares = coursewaresId
      let data = this.courseList.filter((item) => {
        return coursewaresId.includes(item.id)
      })
      data = _.cloneDeep(data)
      data.forEach((item) => {
        const obj = res.coursewares.find((val) => {
          return val.coursewareId === item.id
        })
        item.isCompulsory = obj.isCompulsory
        item.credit = obj.credit
      })
      this.tableList = data
      // 人员处理
      const persons = res.persons.map((item) => {
        const val = {
          id: item.userId,
          name: item.userName,
          organizationUnitName: item.orgUnitName,
          organizationUnitId: item.orgUnitId,
          keyId: item.orgUnitId + item.userId,
        }
        return val
      })
      this.getPersonList(persons)
    },
    // 课件处理
    courseHandle() {
      if (this.formData.coursewares.length) {
        const arr = []
        this.formData.coursewares.forEach((id) => {
          const val = this.courseList.find((item) => {
            return item.id === id
          })
          val && arr.push(val)
        })
        // let data = this.courseList.filter((item) => {
        //   return this.formData.coursewares.includes(item.id)
        // })
        const data = _.cloneDeep(arr)
        let count = 0
        data.forEach((item) => {
          const oldData = this.tableList.find((val) => {
            return val.id === item.id
          })
          item.isCompulsory = oldData ? oldData.isCompulsory : false
          item.credit = oldData ? oldData.credit : 1
          if (item.isCompulsory) {
            count += item.times
          }
        })
        this.tableList = _.cloneDeep(data)
        this.formData.qualifiedCreditHours = count
        this.timer = formatSeconds(this.formData.qualifiedCreditHours).split(':')
      } else {
        this.tableList = []
        this.timer = this.$options.data().timer
        this.formData.qualifiedCreditHours = undefined
      }
    },
    compulsoryChange() {
      let count = 0
      this.tableList.forEach((item) => {
        if (item.isCompulsory) {
          count += item.times
        }
      })
      this.formData.qualifiedCreditHours = count
      this.timer = formatSeconds(this.formData.qualifiedCreditHours).split(':')
      this.tableList = _.cloneDeep(this.tableList)
    },
    // 返回选择人员的id
    changePersonSelect(data) {
      this.formData.publisherName = data.name
    },
    getPersonList(personList) {
      this.personList = personList.map((item) => {
        return {
          userName: item.name,
          name: item.name,
          userId: item.id,
          keyId: item.keyId,
          orgUnitName: item.organizationUnitName,
          orgUnitId: item.organizationUnitId,
        }
      })
      this.formData.persons = this.personList.reduce((pre, cur, index) => {
        pre += cur.name + (index === this.personList.length - 1 ? '' : ',')
        return pre
      }, '')
    },
    async submitForm() {
      await this.$refs.formRef.validate()
      const data = _.cloneDeep(this.formData)
      data.trainingDateStart = data.trainingDate[0]
      data.trainingDateEnd = data.trainingDate[1]
      if (!data.reminderTime) {
        data.reminderTime = null
      }
      const timeKeys = ['trainingDateStart', 'trainingDateEnd', 'reminderTime']
      timeKeys.forEach((time) => {
        if (data[time]) {
          data[time] = dayjs(data[time]).format('YYYY-MM-DD HH:mm:ss')
        }
      })
      if (!this.formData.publisherId) {
        data.publisherId = null
        data.publisherName = null
      }
      data.qualifiedCredits = Number(data.qualifiedCredits)
      // const timeArr = data.qualifiedCreditHours.split(':')
      // data.qualifiedCreditHours = timeArr[0] * 3600 + timeArr[1] * 60 + Number(timeArr[2])
      const scoreNum = { min: 0, max: 0 }
      const timesNum = { min: 0, max: 0 }
      data.coursewares = this.tableList.map((item, index) => {
        const val = {
          coursewareId: item.id,
          isCompulsory: item.isCompulsory,
          credit: item.credit,
          orderNo: index,
        }
        if (item.isCompulsory) {
          scoreNum.min += item.credit
          timesNum.min += item.times
        }
        scoreNum.max += item.credit
        timesNum.max += item.times
        return val
      })
      if (scoreNum.min > data.qualifiedCredits || scoreNum.max < data.qualifiedCredits) {
        this.$message.warning('合格分数不能低于课件必修课总分且不能高于课程总分')
        return
      }
      if (timesNum.min > data.qualifiedCreditHours || timesNum.max < data.qualifiedCreditHours) {
        this.$message.warning('合格学时不能低于课件必修课总时长且不能高于课程总时长')
        return
      }
      data.persons = this.personList
      if (this.operateType === 'update') {
        data.id = this.operateData.id
      }
      this.loading = true
      const [err, res] = await trainingPlanApi[this.operateType === 'update' ? 'update' : 'insert'](
        {
          body: data,
        }
      )
      this.loading = false
      if (err) return
      this.$message.success('提交成功')
      this.$emit('success')
      this.dialogVisible = false
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-icon-arrow-right {
  display: none;
}
</style>
